import { render, staticRenderFns } from "./SectionRemitosA4.vue?vue&type=template&id=4955b4b0&"
import script from "./SectionRemitosA4.vue?vue&type=script&lang=js&"
export * from "./SectionRemitosA4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports